import { render, staticRenderFns } from "./LmRecipients.vue?vue&type=template&id=2ec43b8c"
import script from "./LmRecipients.vue?vue&type=script&lang=js"
export * from "./LmRecipients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports